/**
 * Auto-generated file - do not edit by hand
 * Run `pnpm ui:generate:icons` to regenerate
 * Source: source/svg/check.svg
 */
import type { IconProps } from '../types';
const Check = ({ size, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="m3.668 12.336 5.334 6.668L20.338 5"
    />
  </svg>
);
export default Check;
